<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-row>
        <v-col cols="3">
            <v-select
                v-model="complaint.complaintWayOfProceeding.complaintWayOfProceedingId"
                :items="proceedingWays"
                label="Sposób postępowania dla zgłaszanej reklamacji"
                item-value="id"
                item-text="name"
                clearable
                :disabled="isReadOnly"
                :error="isFieldInvalid('complaintWayOfProceedingId')"
                :error-messages="validationMessages('complaintWayOfProceedingId')"
                @blur="triggerBlur('complaintWayOfProceedingId')"
                @change="handleProceedingChange"
            />
        </v-col>

        <v-col v-if="complaint.complaintWayOfProceeding.complaintWayOfProceedingId === adjustmentId" cols="3">
            <v-text-field
                v-model="complaint.complaintWayOfProceeding.value"
                label="Ilość poświęconych roboczogodzin (w min)"
                type="number"
                inputmode="numeric"
                clearable
                suffix="min"
                :disabled="isReadOnly"
                :error="isFieldInvalid('complaintWayOfProceedingValue')"
                :error-messages="validationMessages('complaintWayOfProceedingValue')"
                @blur="triggerBlur('complaintWayOfProceedingValue')"
            />
        </v-col>

        <v-col v-if="complaint.complaintWayOfProceeding.complaintWayOfProceedingId === reprintId" cols="auto">
            <v-row>
                <span style="font-size: 14px;">
                    Czy chcesz uruchomić dodruk?
                </span>
            </v-row>

            <v-row justify="center">
                <v-btn
                    depressed
                    small
                    :color="setSelectedReprintButtonColor(reprintYes)"
                    :disabled="isReadOnly"
                    @click="handleSetReprintValue(reprintYes)"
                >
                    {{ reprintYes }}
                </v-btn>

                <v-btn
                    depressed
                    small
                    class="ml-2"
                    :color="setSelectedReprintButtonColor(reprintNo)"
                    :disabled="isReadOnly"
                    @click="handleSetReprintValue(reprintNo)"
                >
                    {{ reprintNo }}
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { PROCEEDING_TYPES } from '../../helpers/constants'

/* eslint-disable vue/no-mutating-props */
export default {
    name: 'DetailsTabWayOfProceedingSection',

    props: {
        complaint: {
            type: Object,
            required: true,
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
        isReadOnly: {
            type: Boolean,
        }
    },

    data() {
        return {
            adjustmentId: PROCEEDING_TYPES.ADJUSTMENT,
            reprintId: PROCEEDING_TYPES.REPRINT,
            noReprintId: PROCEEDING_TYPES.NO_REPRINT,
            reprintYes: 'TAK',
            reprintNo: 'NIE',
        }
    },

    computed: {    
        proceedingWays() {
            return this.$store.state.complaints.internalComplaints.proceedingWays
        }
    },

    watch: {
        'complaint.complaintWayOfProceeding.complaintWayOfProceedingId'(value) {
            this.syncProceedingDefaults(value)
        }
    },

    mounted() {
        this.syncProceedingDefaults(this.complaint?.complaintWayOfProceeding?.complaintWayOfProceedingId)
    },

    methods: {
        validationNode(field) {
            return this.validation[field] || null
        },

        isFieldInvalid(field) {
            const node = this.validationNode(field)

            return Boolean(node && node.error)
        },

        validationMessages(field) {
            const node = this.validationNode(field)

            if (!node || !Array.isArray(node.messages)) return []

            return node.messages
        },

        triggerBlur(field) {
            this.$emit('field-blur', field)
        },

        handleProceedingChange(value) {
            this.triggerBlur('complaintWayOfProceedingId')
            this.syncProceedingDefaults(value)

            if (value === this.adjustmentId) this.triggerBlur('complaintWayOfProceedingValue')
        },

        syncProceedingDefaults(value) {
            if (value === this.reprintId) {
                const current = this.complaint.complaintWayOfProceeding.value

                if (![this.reprintYes, this.reprintNo].includes(current)) {
                    this.complaint.complaintWayOfProceeding.value = this.reprintYes
                }

                return
            }

            if (value === this.adjustmentId) {
                return
            }

            if (value === this.noReprintId || value == null) {
                if (this.complaint.complaintWayOfProceeding.value !== null) {
                    this.complaint.complaintWayOfProceeding.value = null
                }

                return
            }

            if (this.complaint.complaintWayOfProceeding.value !== null) {
                this.complaint.complaintWayOfProceeding.value = null
            }
        },

        handleSetReprintValue(value) {
            this.complaint.complaintWayOfProceeding.value = value
        },

        setSelectedReprintButtonColor(value) {
            const current = this.complaint.complaintWayOfProceeding.value

            if (!current) return ''

            if (String(current).toLowerCase() === String(value).toLowerCase()) {
                return 'primary'
            }

            return ''
        },
    },
}
</script>
